<script lang="ts">
	import CaseStudyCard from "@components/CaseStudyCard.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Button from "@components/common/Button.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import type { CaseStudiesProps } from "./CaseStudiesProps.js";

	const { caseStudies, mainCaseStudy }: CaseStudiesProps = $props();
	let caseStudyToLoadCount = $state(9);
</script>

<Layout>
	<div class="full-width max-w-[120rem] lg:mx-8 place-self-center">
		<HugeHeading
			level={1}
			class="!mb-4 md:!mb-8 text-center [&_br]:hidden md:[&_br]:inline mild"
			text="Ušetřené miliony, stroke[[rychlé nl[[]] sklady i fungující týmy]]"
		/>
		<p
			class="text-[1.25rem]/[1.2] md:text-xl/[1.2] lg:text-[2rem]/[1.2] font-bold tracking-[0.01em] mb-20 xs:mb-28 sm:mb-32 md:mb-36 lg:mb-40 xl:mb-44 2xl:mb-48 text-center text-cmcsecondary"
		>
			<Formatted text="Podívejte se, komu a jak jsme pomohli zlepšit logistiku." />
		</p>
	</div>

	{#if mainCaseStudy}
		<section class="2xl:full-width 2xl:w-[1600px] xl:mx-auto w-full">
			<CaseStudyCard hugeImage horizontal caseStudy={mainCaseStudy} class="w-full" />
		</section>
	{/if}
	<section class="2xl:full-width 2xl:w-[1600px] xl:mx-auto py-8 md:py-16 lg:py-20">
		<div class="grid grid-cols-2 lg:grid-cols-3 gap-1 md:gap-2 items-stretch">
			{#each caseStudies.slice(0, caseStudyToLoadCount) as caseStudy (caseStudy.id)}
				<CaseStudyCard {caseStudy} class="max-w-[33rem] w-full" />
			{/each}
			{#if caseStudyToLoadCount < caseStudies.length}
				<div class="col-span-full mt-16">
					<Button
						onclick={(): void => {
							caseStudyToLoadCount += 9;
						}}
						variant={ButtonVariant.Outlined}
						icon="arrow"
						class="inline-flex justify-between w-[21.25rem]"
					>
						<Formatted text="Načíst další" />
					</Button>
				</div>
			{/if}
		</div>
	</section>
</Layout>
